<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование заказа" : "Добавление заказа"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs4)
          v-text-field(
            v-model='model.created_at'
            label='Дата создания'
            readonly
          )
        v-flex(xs4)
          v-text-field(
            v-model='model.number_str'
            label='Номер заказа'
            readonly
          )
        v-flex(xs4)
          v-text-field(
            v-model='model.status_name'
            label='Статус'
            readonly
          )
      v-layout(wrap)
        v-flex(xs4)
          v-text-field(
            v-model='model.sum'
            label='Сумма заказа'
            readonly
          )
        v-flex(xs4)
          v-text-field(
            v-model='model.discount_percent'
            label='Скидка в %'
            readonly
          )
        v-flex(xs4)
          v-text-field(
            v-model='model.discount_sum'
            label='Сумма скидки'
            readonly
          )
      v-layout(wrap)
        v-flex(xs6)
          v-text-field(
            v-model='model.sum_to_pay'
            label='Сумма к оплате'
            readonly
          )
        v-flex(xs6)
          v-text-field(
            v-model='model.paid_status_name'
            label='Статус оплаты'
            readonly
          )
      v-layout(wrap)
        v-flex(xs12)
          v-textarea(
            v-model='placeName'
            label='Место получения'
            readonly
            rows="4"
          )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='model.items'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Название товара') {{ props.item.good.name }}
          td(data-label='Превью товара')
            div
              v-img(
                :lazy-src='props.item.good.avatar_url'
                :src='props.item.good.avatar_url'
                class='grey lighten-4'
                max-height="100"
                contain
              )
          td(data-label='Количество') {{ props.item.count }}
          td(data-label='Цена') {{ props.item.price }}
          td(data-label='Сумма') {{ props.item.sum }}
    v-card-actions(class='large')
      v-spacer
      v-btn(
        v-if='model.status_id === "basket" || model.status_id === "new"'
        @click='changeOrderStatus("canceled")'
        :loading='isLoading'
        color='primary'
        depressed
      ) Отменить
      v-btn(
        v-if='model.status_id === "new"'
        @click='changeOrderStatus("paid")'
        :loading='isLoading'
        color='primary'
        depressed
      ) Пометить оплаченным
      v-btn(
        v-if='model.status_id === "paid"'
        @click='changeOrderStatus("issued")'
        :loading='isLoading'
        color='primary'
        depressed
      ) Выдать
      s-back-btn
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import http from "@/http";

export default {
  props: ['id'],

  data: () => ({
    model: {},
    headers: [
      { text: '#ID', align: 'left', width: '0%', sortable: false },
      { text: 'Название товара', align: 'left', width: '40%', sortable: false },
      { text: 'Превью товара', align: 'left', width: '20%', sortable: false },
      { text: 'Количество', align: 'left', width: '0%', sortable: false },
      { text: 'Цена', align: 'left', width: '0%', sortable: false },
      { text: 'Сумма', align: 'left', width: '0%', sortable: false }
    ]
  }),

  async created() {
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
    },

    async changeOrderStatus(status) {
      try {
        await http.post(`shop/orders/${this.id}/${status}`)
        this.$root.showSnack('Статус заказа обновлен')
        this.updateItem()
      } catch(error) {
        this.$root.showSnack('Ошибка смены статуса заказа')
      }
    },

    ...mapActions('shop/orders', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    placeName() {
      const pickup_type_name = this.model.pickup_type_name ? this.model.pickup_type_name : ''
      const pickup_name = this.model.pickup_name ? this.model.pickup_name : ''
      return pickup_type_name + '\r\n\r\n' + pickup_name
    },
    ...mapGetters('shop/orders', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
